import { render, staticRenderFns } from "./LayerPublishForm.vue?vue&type=template&id=a4768a5e&"
import script from "./LayerPublishForm.vue?vue&type=script&lang=js&"
export * from "./LayerPublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports